import {
   appendTestableComponentAttributes,
   MarginPosition,
   Notification,
   NotificationSize,
   NotificationType,
   StyledFlex,
   StyledMargin,
   ValidationErrorNotification,
} from '@dreryk/react-components';

import { hasReimbursementFull } from '~libs.shared.prescription';

import { draftPrescriptionsTranslationKeys } from '../../../translations';
import { useNfzConfigurationNecessaryChecker } from '../prescriptions/draftPrescriptions/nfz/useNfzConfigurationNecessaryChecker';

import { ReimbursementSelectorContentProps } from './ReimbursementSelector.types';
import { ReimbursementSelectorContentReimbursement } from './ReimbursementSelectorContentReimbursement';

export const ReimbursementSelectorContent = (props: ReimbursementSelectorContentProps): JSX.Element => {
   const checkNfzConfigurationNecessary = useNfzConfigurationNecessaryChecker();

   return (
      <StyledFlex
         direction={'column'}
         {...appendTestableComponentAttributes('ReimbursementPrescriptionSelector', props.testId)}
      >
         <StyledMargin left={-6}>
            <StyledFlex direction={'row'} flexWrap={'nowrap'} gap={'2px'}>
               {props.reimbursements.map((reimbursement) => {
                  return (
                     <ReimbursementSelectorContentReimbursement
                        key={reimbursement.code}
                        reimbursement={reimbursement}
                        selectedEntitlements={props.selectedEntitlements}
                        visitDiagnoses={props.visitDiagnoses}
                        onChange={props.onChange}
                        value={props.value}
                     />
                  );
               })}
            </StyledFlex>
         </StyledMargin>
         {props.error ? (
            <ValidationErrorNotification testId={'error'} label={props.error} margin={MarginPosition.TOP} />
         ) : null}
         {props.value && !hasReimbursementFull(props.value) && checkNfzConfigurationNecessary() ? (
            <Notification
               testId={'nfzDepartmentMissing'}
               type={NotificationType.WARNING}
               label={draftPrescriptionsTranslationKeys.branchReimbursementAgreementSignedHasNotBeenSelected}
               margin={MarginPosition.TOP}
               size={NotificationSize.SMALLER}
            />
         ) : null}
      </StyledFlex>
   );
};
